import React from 'react';
import { useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';

const CardImage = observer((props) => {
  const {
    data,
    event,
    effect,
    position,
  } = props;

  const [imgClassName, setImageClassName] = useState("");
  const url = useMemo(() => {
    if(data){
      return data;
    }
    if(event.status == "success"){
      try{
        return event.detail.results[0].url;
      } catch(e){}
    }
    return "";
  }, [data, event.status]);
  useEffect(() => {
    if(url && /\.svg$/i.test(url)){
      setImageClassName('w-full');
    }
  }, [url]);

  return (
    <div className="size-full flex items-center justify-center px-24px pt-8px pb-24px overflow-hidden">
      <div className={`inline-block rounded-12px overflow-hidden relative ${imgClassName}`}>
        {
          effect ? (<div className="size-full absolute left-0 top-0 z-1 border-flash">
            { position?.x && position?.y ? (
                <img
                  className="absolute"
                  src="https://p1.ssl.qhimg.com/t110b9a930157fe0d68c5ea1c10.gif"
                  style={{
                    left: position?.x,
                    top: position?.y,
                    width: '8%',
                  }}
                />
              ) : null
            }
          </div>) : null
        }
        <img className={`display-block max-w-full max-h-full ${imgClassName}`} src={url} />
      </div>
    </div>
  )
});

export default CardImage;